module.exports = __webpack_public_path__ + "static/Ola_2-ca0bedb0a94fa77d70020bca5de103b0.jpg";